import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '../Page/Div';
import { WPImage } from '../UI/WPImage';
const SectorsCards = ({ content, idx, allowOpen }) => {
    const { title, cards } = content.sectors_cards ?? {};
    return (_jsxs("div", { className: "sectors-cards", children: [_jsx(Div, { className: "sectors-cards-title", children: title }), _jsx(Div, { className: "sectors-cards-container", children: _jsx("div", { className: "sectors-cards-slider", children: cards.map((card) => {
                        const { title, details, image } = card;
                        return (_jsxs("div", { className: "sectors-card-wrapper", children: [_jsx("div", { className: "sectors-card-title", children: title }), _jsx("div", { className: "sectors-card-image-wrapper", children: _jsx(WPImage, { id: image }) }), _jsx("div", { className: "sectors-card-details alt-font", children: details })] }, title));
                    }) }) })] }));
};
export default SectorsCards;
